window.tokchartPlanClarity = () => ({
    variant: 'control',
    started: false,
    onReady: null,
    init() {
        this.onReady = () => this.start();
        window.addEventListener('tokchart:analytics-ready', this.onReady);
        if (window.posthog?.__loaded && window.tokchartConsent?.analytics) this.start();
    },
    async start() {
        if (this.started || !this.$el.isConnected) return;
        this.started = true;
        await window.tokchartExperiments.render('plan-clarity-2026-10', async (variant) => {
            if (!this.$el.isConnected) throw new Error('Plans no longer visible');
            this.variant = variant;
            await this.$nextTick();
            // Wait until Alpine has applied visibility before confirming exposure.
            await new Promise(resolve => requestAnimationFrame(resolve));
            if (!this.$el.isConnected) throw new Error('Plans no longer visible');
        });
    },
    destroy() {
        window.removeEventListener('tokchart:analytics-ready', this.onReady);
    },
});
